import Ajax from '@/lib/ajax'

export default {
  /**
   * 根据款号同步中台商品
   * @param itemCode
   */
  syncProduct(itemCode: string) {
    return Ajax.get(`/api/ExternData/product/${itemCode}`)
  }
}
